import Select from "react-select";
import {
  RequiredManager,
  ValidationMessage
} from "../../../shared/RequieredManager";
import { AdditionalDefinitionItems } from "../Criterion";

type ListSelectorProps = {
  listValue: { value: string; label: string }[];
  items: AdditionalDefinitionItems;
  onListChange: (
    value: string[] | undefined,
    items: { value: string; label: string }[]
  ) => void;
  requiredManager: RequiredManager;
  placeholder: string;
};

export const ListSelector = ({
  listValue,
  items,
  onListChange,
  requiredManager,
  placeholder
}: ListSelectorProps) => {
  const options = items.map((x) => ({
    label: x.Value,
    value: x.AdditionalDefinitionItemID.toString()
  }));

  return (
    <div className="input-column">
      <Select
        isMulti
        isClearable={false}
        defaultValue={listValue}
        value={listValue}
        options={options}
        onChange={requiredManager.makeRequiredWithId((values) => {
          const selectedValues = values
            ? (values as any[]).map((x) => x.value)
            : [];
          onListChange(selectedValues, options);
        }, "validationId")}
        placeholder={placeholder}
        classNamePrefix={"multiple-choice-select"}
      />
      <ValidationMessage
        onChange={requiredManager.getValidation("validationId")}
        validationMethod={(value?: { value: string; label: string }[]) =>
          !!value && value.length > 0
        }
        defaultValue={listValue}
      />
    </div>
  );
};
